import { Injectable } from '@angular/core';
import { clearLocalStorage } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  constructor() { }
  //todo da decommentare quando si vuole usare il jwt
  /*saveToken(token: string): void {
    if(!localStorage.getItem('jwt_token')){
      localStorage.setItem('jwt_token', encryptObject(token));
    }
  }

  getToken(): string | null {
    return decryptToObject(localStorage.getItem('jwt_token'));
  }

  isLoggedIn(): boolean {
    const token = this.getToken();
    return token != null;
  }

  logOut(){
    localStorage.removeItem('jwt_token');
  }*/
   // todo decommentare e commentare sopra se si vuole usare il cookie service

  isLoggedIn(): boolean {
    const currentUser = localStorage.getItem("CurrentUser");
    return currentUser != null;
  }

  logOut(){
    clearLocalStorage();
  }
}
